import { ButtonV2, TextLink } from '@moneyforward/ap-frontend-components';

import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './TransactionDetailOptionButtonGroup.module.scss';

export type Props = {
  onAdd: () => void;
  onImport: () => void;
  isDisabled: boolean;
};

const cx = classNames.bind(styles);

export const TransactionDetailOptionButtonGroup: FC<Props> = memo(
  ({ onAdd, onImport, isDisabled }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleImportExportHistoryClick = () => {
      navigate(
        {
          pathname: '/import_export_histories',
          search: '?source=custom_transaction_items',
        },
        {
          state: { from: location.pathname },
        }
      );
    };

    return (
      <div className={cx(styles['button-group'])}>
        <TextLink
          className={cx(styles['link-button'])}
          href={undefined}
          onClick={handleImportExportHistoryClick}
        >
          {t('import_export_history_link_text')}
        </TextLink>
        <ButtonV2 isTertiary onClick={onImport} isDisabled={isDisabled}>
          {t('import')}
        </ButtonV2>
        <ButtonV2 onClick={onAdd} isDisabled={isDisabled}>
          {t('add')}
        </ButtonV2>
      </div>
    );
  }
);
TransactionDetailOptionButtonGroup.displayName =
  'TransactionDetailOptionButtonGroup';
